/**
 * SPERRENE SLIK GODKJENNINGSSIDEN, AI-SIDEN OG MCP-EN VISER DEM (revisjonen 02.11). Nøklene oversettes
 * som `ai.blocked.<key>` og `ai.approval.<key>`. Rekkefølgen er Atles. Det som ikke står her, kan AI-en
 * gjøre direkte, innenfor brukerens rettigheter.
 */
export const EXTERNAL_BLOCKED_GROUPS = ['deleteMainObjects', 'contracts', 'organizationAndAccount'] as const;
export type ExternalBlockedGroup = (typeof EXTERNAL_BLOCKED_GROUPS)[number];

/** Bare med manuell godkjenning i AI-en: tokenet fra `AI_CONFIRMATION_REQUIRED` sendes med kallet. */
export const EXTERNAL_APPROVAL_GROUPS = ['money', 'outbound'] as const;
export type ExternalApprovalGroup = (typeof EXTERNAL_APPROVAL_GROUPS)[number];
